import { env } from "./config";

const isProd = env === "production";

export const PLATFORMS = {
  pccm: {
    name: "PCCM",
    role_enum: "PCCM_ROLES",
    platform: "pccm",
  },
  zxdx: {
    name: "专修单修",
    role_enum: "ZXDX_ROLES",
    platform: "zxdx",
  },
  hxylt: {
    name: "呼吸医联体",
    role_enum: "HXYLT_ROLES",
    platform: "hxylt",
  },
  hospital: {
    name: "互联网医院",
    role_enum: "HOSPITAL_ROLES",
    platform: "hospital",
  },
  www: {
    name: "中国呼吸联合体",
    role_enum: "WWW_ROLES",
    platform: "www",
  },
  ild: {
    name: "间质性肺疾病",
    role_enum: "ILD_ROLES",
    platform: "ild",
  },
};

export const PCCM_ROLES = {
  hospital: {
    name: "医院填报用户",
    icon: "user",
    key: "hospital",
    redirect: isProd ? "https://pccm.hxylt.org.cn/f" : "http://pccm.doclive.cn/f",
  },
  specialist: {
    name: "评审专家",
    icon: "expert",
    key: "specialist",
    redirect: isProd
      ? "http://m.hxylt.org.cn/pages/pccmonline_expert_list.html"
      : "http://m.doclive.cn/pages/pccmonline_expert_list.html",
  },
  admin: {
    name: "管理员",
    icon: "admin",
    key: "admin",
    redirect: isProd
      ? "https://pccm.hxylt.org.cn/a?login"
      : "https://pccm.doclive.cn/a?login",
  },
};

export const HXYLT_ROLES = {
  doctor: {
    name: "用户",
    icon: "student",
    key: "doctor",
    redirect: isProd ? "http://www.hxylt.org.cn" : "http://test.hxylt.cn/",
  },
  admin: {
    name: "管理员",
    icon: "admin",
    key: "admin",
  },
};
export const ZXDX_ROLES = {
  admin: {
    name: "项目管理员",
    icon: "admin",
    key: "admin",
    redirect: isProd
      ? "http://zxdx.hxylt.org.cn/admin/index"
      : "http://zxdx.hxylt.cn/admin/index",
  },
  hospital: {
    name: "基地医院",
    icon: "hospital",
    key: "hospital",
    redirect: isProd
      ? "http://zxdx.hxylt.org.cn/hospital/index"
      : "http://zxdx.hxylt.cn/hospital/index",
  },
  student: {
    name: "学员",
    icon: "student",
    key: "student",
    redirect: isProd
      ? "http://zxdx.hxylt.org.cn/user/index"
      : "http://zxdx.hxylt.cn/user/index",
  },

  sysadmin: {
    name: "系统管理员",
    icon: "admin",
    key: "sysadmin",
    redirect: isProd
      ? "http://zxdx.hxylt.org.cn/sysConfig/index"
      : "http://zxdx.hxylt.cn/sysConfig/index",
  },
  specialist: {
    name: "评分专家",
    icon: "expert",
    key: "specialist",
    redirect: isProd
      ? "http://zxdx.hxylt.org.cn/scoreExpert/videoScore"
      : "http://zxdx.hxylt.cn/scoreExpert/videoScore",
  },
};

export const HOSPITAL_ROLES = {
  admin: {
    name: "审方药师",
    icon: "admin",
    key: "admin",
    redirect: isProd
      ? "http://hospital.hxylt.org.cn/hospital/#/electronicPrescription"
      : "http://hospital.hxylt.cn/hospital/#/electronicPrescription",
  },
  patient: {
    name: "患者",
    icon: "patient",
    key: "patient",
    redirect: isProd
      ? "http://hospital.hxylt.org.cn/#/personalCenter?userType=1"
      : "http://hospital.hxylt.cn/#/personalCenter?userType=1",
  },
  doctor: {
    name: "医生",
    icon: "student",
    key: "doctor",
    redirect: isProd
      ? "http://hospital.hxylt.org.cn/#/workbench?userType=2"
      : "http://hospital.hxylt.cn/#/workbench?userType=2",
  },
};
// 呼吸联合体官网
export const WWW_ROLES = {
  doctor: {
    name: "医生",
    icon: "student",
    key: "doctor",
    redirect: isProd
      ? "https://cn.hxylt.org.cn"
      : "http://wwwtest.hxylt.cn/web/",
  },
};
// 间质性肺疾病
export const ILD_ROLES = {
  hospital: {
    name: "医院填报用户",
    icon: "user",
    key: "hospital",
    redirect: isProd ? "http://ild.doclive.cn/f" : "http://ild.doclive.cn/f",
  },
  specialist: {
    name: "评审专家",
    icon: "expert",
    key: "specialist",
    redirect: isProd
      ? "http://ild.zj.doclive.cn/pages/pccmild_expert_list.html"
      : "http://ild.zj.doclive.cn/pages/pccmild_expert_list.html",
  },
  admin: {
    name: "管理员",
    icon: "admin",
    key: "admin",
    redirect: isProd
      ? "http://ild.doclive.cn/a?login"
      : "http://ild.doclive.cn/a?login",
  },
};

// 把上面所有的roles放到dist中
export const ROLE_DIST = {
  PCCM_ROLES,
  HXYLT_ROLES,
  ZXDX_ROLES,
  HOSPITAL_ROLES,
  WWW_ROLES,
  ILD_ROLES
};


